import {
  SAVE_BOOK_SIZES,
  LOAD_BOOK_SIZES_BY_BOOK_ID,
  UPDATE_BOOK_RATIO,
  UPDATE_BOOK_SIZES,
} from './../../action-types/bookproperties';

export const STATE_KEY = 'bookSizes';

export const bookSizes = (state = {
  width: 0,
  height: 0,
  ratio: 0,
}, action) => {
  switch (action.type) {
    case SAVE_BOOK_SIZES: {
      const {
        width,
        height,
        margin,
        ratio,
      } = action;
      return {
        width,
        height,
        margin,
        ratio,
      };
    }

    case UPDATE_BOOK_RATIO: {
      const { ratio } = action;

      return Object.assign({}, state, { ratio });
    }

    case UPDATE_BOOK_SIZES: {
      const { sizes } = action;

      return Object.assign({}, state, { sizes });
    }

    case LOAD_BOOK_SIZES_BY_BOOK_ID: {
      return action.bookState;
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/bookproperties/bookSizes.js